import { ISubBuilderPurchaseType, ISubBuilderStep } from './types'

export const SUBSCRIPTION_TYPES: ISubBuilderPurchaseType[] = ['gift', 'me']
export const STEP_ORDER_GIFT : ISubBuilderStep[] = [ 'roast', 'grind', 'duration', 'quantity', 'date', 'summary']
export const STEP_ORDER_ME: ISubBuilderStep[] = ['roast', 'grind', 'routine', 'summary']

